import { onboardingShownForScreen, logOnboardingShown } from "../../utils/onboarding";

const screenName = 'onboardingShownSmart';

const steps = [
    {
        img: '/images/onboarding/onboarding-plan2.jpg',
        description: '<span style="font-size: 16px;">Use Smart by DentiCalc to <b>create plans in seconds</b>. Clarify treatment options, build more trust and <b>increase case acceptance</b> and patient retention.<br/><br/>And there is one more huge thing DentiCalc can do for you...',
        buttons: [
            {
                text: "Show me!",
                class: "primary",
                click: (ctx) => {
                    ctx.currentStep++;
                }
            }
        ],
        mounted: () => {
            logOnboardingShown(screenName);
        }
    },
    {
        img: '/images/onboarding/onboarding-teeth.jpg',
        description: '<span style="font-size: 16px;">With our industry-leading solution DentiCalc can <b>animate the plan</b> so you can visually guide your patients through their own case to help them <b>commit to care</b>.',
        buttons: [
            {
                text: "Let's do this!",
                class: "primary",
                click: (ctx) => {
                    ctx.currentStep++;
                }
            }
        ],
        skipBtn: "<br/><br/>Note: Don\'t forget to enter your own currency and prices in the settings.",
    }
]

export const onboarding = () => {
    return onboardingShownForScreen(screenName) === 0 ? steps : [];
}
